import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PlatformType } from 'src/environments/platform-type.enum';

@Component({
    selector: 'app-icon-facility-supplies',
    templateUrl: './icon-facility-supplies.component.html',
    styleUrls: ['./icon-facility-supplies.component.scss']
})
export class IconFacilitySuppliesComponent implements OnInit {

    @Input() cssClass = 'icon--18';

    currentPlatform = environment.platformId;
    PLATFORM_TYPE = PlatformType;

    constructor() { }

    ngOnInit(): void {
    }

}
